module.exports = __webpack_public_path__ + "static/media/star.b6d8aa30.svg";